export default {"src":"/_next/static/media/discord_color.074cf668.svg","height":17,"width":22,"blurWidth":0,"blurHeight":0};